import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { componentKey, setDownloadAllPdfModal, setLoadingState, setPaginationState, setSelectedStateFormsStates, setStateFilingGridData, setStateForms } from "./ManageStateFormsSlice";
import { PAGE_STATE } from "../../../constants/constants";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import ManageFormsService from "../../../../../services/ManageFormsService";
import General from "../../../../../libs/utility/General";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { MANAGE_STATE_FORMS_LOADING_STATES } from "../constants";

export const { getStateFilingGridData, getStatePDF, getStateExcelExport, blockStateFiling, getStateForms, downLoadStatePDFs } = {
    getStateFilingGridData: (payload) => {
        return {
            type: "MANAGE_FORMS/STATE_FORMS/GET_STATE_FILING_GRID_DATA",
            payload
        }
    },

    getStatePDF: (payload) => {
        return {
            type: "MANAGE_FORMS/STATE_FORMS/GET_STATE_PDf",
            payload
        }
    },

    getStateExcelExport: (payload) => {
        return {
            type: "MANAGE_FORMS/STATE_FORMS/GET_STATE_EXCEL_EXPORT",
            payload
        }
    },

    blockStateFiling: (payload) => {
        return {
            type: "MANAGE_FORMS/STATE_FORMS/BLOCK_STATE_FILING",
            payload
        }
    },

    getStateForms: (payload) => {
        return {
            type: "MANAGE_FORMS/GET_STATE_FORMS",
            payload
        }
    },

    downLoadStatePDFs: (payload) => {
        return {
            type: "MANAGE_FORMS/DOWNLOAD_STATE_PDF",
            payload
        }
    }
}

function* getStateFilingGridDataAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_STATE_FORMS_LOADING_STATES.GRID_DATA_LOADING }))

        const { formName, payerId, taxYear, PageNumber, PageSize } = action.payload

        const params = {
            formName,
            payer: payerId,
            taxYear,
            PageNumber,
            PageSize
        }

        const response = yield ManageFormsService.getStateFilingGridData(params)

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(setStateFilingGridData(General.extractDataFromResponseData(response.data)));
            yield put(setPaginationState({ totalRecipients: General.extractPaginationTotalFromResponse(response.data) }))
        } else {
            yield put(addNotifications({ heading: "Failed to get state form list", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to get state form list", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_STATE_FORMS_LOADING_STATES.GRID_DATA_READY }))
    }
}

function* getStatePDFAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_STATE_FORMS_LOADING_STATES.GRID_DATA_LOADING }))

        const { formName, reconFormId } = action.payload

        const response = yield ManageFormsService.getStatePDF({ reconFormId, formName })

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.openBase64FileInNewTab(Data.Base64, Data.Name)
        } else {
            yield put(addNotifications({ heading: "Failed to get state pdf", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to get state pdf", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_STATE_FORMS_LOADING_STATES.GRID_DATA_READY }))
    }
}

function* getStateExcelExportAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_STATE_FORMS_LOADING_STATES.GRID_DATA_LOADING }));

        const { formName, taxYear, payer } = action.payload;

        const response = yield ManageFormsService.getStateExport({ formName, taxYear, payer });

        const { Message, Status, Data } = response?.data;
        const { Base64, Name } = Data;

        if (Status) {
            General.downloadFileFromBase64(Base64, Name);
        } else {
            yield put(addNotifications({ heading: "Failed to export the excel file", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to export the excel file", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_STATE_FORMS_LOADING_STATES.GRID_DATA_READY }))
    }
}

function* blockStateFilingAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_STATE_FORMS_LOADING_STATES.GRID_DATA_LOADING }));

        const { reconState, formName, reconFormId } = action?.payload;
        const response = yield ManageFormsService.blockStateFiling({ reconFormId, reconState, formName });
        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: Message, message: "Successfully blocked state filing", variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Failed to block state filing", message: Message }));
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to block state filing", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_STATE_FORMS_LOADING_STATES.GRID_DATA_READY }))
    }
}

function* getStateFormsAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_STATE_FORMS_LOADING_STATES.STATE_FORMS_LOADING }))

        const { urlFormId } = action?.payload;
        const response = yield ManageFormsService.getStateForms()

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.addOptionAndValueKeys(Data, "FormName1", "FormId")
            yield put(setStateForms(Data));

            if (urlFormId) {
                const form = Data.find(form => form.FormId == urlFormId);

                if (form) {
                    yield put(setSelectedStateFormsStates({ name: "StateFormName", value: form }))
                }
            }
        } else {
            yield put(addNotifications({ heading: "Failed to fetch state forms", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch state forms", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_STATE_FORMS_LOADING_STATES.STATE_FORMS_READY }))
    }
}

function* downLoadStatePDFsAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_STATE_FORMS_LOADING_STATES.GRID_DATA_LOADING }))

        const { payerName, formName, stateName, taxYear, payerId, isRejected,mergeCopies = false } = action?.payload;
        const response = yield ManageFormsService.downLoadStatePDFs({ payerName, formName, stateName, taxYear, payerId, isRejected, mergeCopies })

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.downloadFileFromBase64(Data.Base64, Data.Name)
            yield put(setDownloadAllPdfModal(false))
        } else {
            yield put(addNotifications({ heading: "Failed to export to excel", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch state forms", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_STATE_FORMS_LOADING_STATES.GRID_DATA_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getStateFilingGridData().type, getStateFilingGridDataAsync),
        takeLatest(getStatePDF().type, getStatePDFAsync),
        takeLatest(getStateExcelExport().type, getStateExcelExportAsync),
        takeLatest(blockStateFiling().type, blockStateFilingAsync),
        takeLatest(getStateForms().type, getStateFormsAsync),
        takeLatest(downLoadStatePDFs().type, downLoadStatePDFsAsync)
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
